// Stops iOS Safari from zooming the page while the newsletter popup is open.
// The popup comes from the Shopify Forms app and lives in its own shadow root,
// so the theme cannot restyle its fields; they are small enough to make Safari
// zoom the page on focus and leave it zoomed. Capping the viewport scale while
// the dialog is open prevents that, and iOS still lets people pinch to zoom.
// Other browsers do not zoom on focus and would lose pinch zoom, so they are
// left alone.
(function () {
  const HOST_SELECTOR = 'shopify-forms-embed';
  const DIALOG_SELECTOR = '[aria-modal]';
  const SCALE_LOCK = 'maximum-scale=1';
  const SHADOW_ROOT_RETRY_MS = 250;
  const SHADOW_ROOT_MAX_TRIES = 40;

  const isIOS =
    /iP(hone|ad|od)/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;

  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;
  const unlockedContent = viewport.getAttribute('content');
  const watchedRoots = new Map();
  let locked = false;

  function sync() {
    let open = false;
    watchedRoots.forEach((root, host) => {
      // The app may close the popup by removing its whole element.
      if (!host.isConnected) watchedRoots.delete(host);
      else if (root.querySelector(DIALOG_SELECTOR)) open = true;
    });
    if (open === locked) return;
    locked = open;
    viewport.setAttribute('content', open ? `${unlockedContent},${SCALE_LOCK}` : unlockedContent);
  }

  function watchHost(host, triesLeft) {
    if (!host.isConnected) return;
    if (host.shadowRoot) {
      watchedRoots.set(host, host.shadowRoot);
      new MutationObserver(sync).observe(host.shadowRoot, { childList: true, subtree: true });
      sync();
    } else if (triesLeft > 0) {
      setTimeout(() => watchHost(host, triesLeft - 1), SHADOW_ROOT_RETRY_MS);
    }
  }

  const seenHosts = new WeakSet();
  function scan() {
    document.querySelectorAll(HOST_SELECTOR).forEach((host) => {
      if (seenHosts.has(host)) return;
      seenHosts.add(host);
      watchHost(host, SHADOW_ROOT_MAX_TRIES);
    });
    sync();
  }

  // The app injects its element after load, as a child of <body>, and may
  // remove it again; keep watching for both.
  new MutationObserver(scan).observe(document.body, { childList: true });
  scan();
})();
